<div [formGroup]="group" [attr.data-test]="config.name">
  <cwc-textarea
    [formControlName]="config.name"
    [attr.id]="config.name"
    [attr.placeholder]="config.placeholder | translate"
    [charCounter]="true"
    [maxlength]="maxlength"
    [required]="isRequired"
    [attr.data-test]="config?.dataTId"
    [attr.data-tid]="config?.dataTId"
    [attr.data-name]="config?.name"
    [status]="fieldControl.invalid && !fieldControl.untouched ? 'error' : ''"
    [statusMessage]="this.controlStatusMessage$ | async | translate"
    [label]="config.label | translate"
    appBlockKeys
    [blockedKeys]="blockedKeys"
    designVersion="v2"
    no-resize
  ></cwc-textarea>
</div>
